export default {"src":"/_next/static/media/logo1.1e79e312.svg","height":32,"width":33};